export default __webpack_public_path__ + "assets/images/for_owners_vy4ka.jpg";